export default __webpack_public_path__ + "static/media/avatar.eaee1ece.png";